import React, { useContext } from 'react';
import { FaGoogle, FaGithub } from 'react-icons/fa';
import { AuthContext } from '../../UserContext';

const Authentication = () => {
  const { user, logInUserWithGoogle } = useContext(AuthContext)


  const handlelogInWitGoogle = () =>{
    logInUserWithGoogle()
    .then(result => {
    })
    .catch(error=>console.error(error))
  }

  return (
      <div>
        {
          user?.uid?
          <></>
          :
          <button type='submit' onClick={handlelogInWitGoogle} className='ease-in-out duration-300 border-[1px] rounded-md border-blue-600 hover:bg-blue-600 hover:text-white w-full py-2 text-md text-blue-600'><FaGoogle className='inline text-lg'/> Login vai google</button>
        }
        {
          user?.uid?
          <></>
          :
        <button type='submit' name='github' className='mt-1 ease-in-out duration-300 border-[1px] rounded-md border-gray-600 hover:bg-gray-600 hover:text-white w-full py-2 text-md text-gray-600'><FaGithub className='inline text-lg'/> Login vai Github</button>
        }
      </div>
  );
};

export default Authentication;